import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ErrorModal from "../components/Modals/ErrorModal";
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, modal: true, errorPath: "" };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, modal: true };
    }
    componentDidCatch(error, info) {
        console.log("errorinfo", info);
        console.error(error);
        // @todo: Call api logger serice, to store error in backend db, to keep track of gui errors
        //   logErrorToMyService(error, info.componentStack);
    }
    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (_jsx(ErrorModal, { errorModal: this.state.modal, setErrorModal: () => {
                    this.setState({
                        modal: false,
                        hasError: false,
                        errorPath: window.location.pathname,
                    });
                    // window.location.href = '/app/home';
                } }));
        }
        if (this.state.errorPath &&
            window.location.pathname === this.state.errorPath) {
            return null;
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
